// import type { DatePickerProps } from "antd";
import { DatePicker, Space } from 'antd';
import moment from 'moment';
// import moment from "moment";
import React, { useState } from 'react';

interface Props {
  handleDateValue: Function;
}

const { RangePicker } = DatePicker;

const dateFormat = 'YYYY-MM-DD';

const DatePickerr = ({ handleDateValue }: Props) => {
  return (
    <Space direction="vertical" size={12} className="busk-datePicker">
      <RangePicker
        placeholder={['YYYY.MM.DD', 'YYYY.MM.DD']}
        onChange={(date: any, datestring: [string, string]) => {
          handleDateValue(datestring);
        }}
        format={dateFormat}
      />
    </Space>
  );
};

export default DatePickerr;
